module.exports = __webpack_public_path__ + "img/SETTING.56f9a6d5.svg";